export const failureTableRowLayout = {
  display: 'grid',
  gridTemplateColumns: '20px minmax(126px, 1fr) minmax(130px, 1.4fr) 72px minmax(110px, 1fr) 32px',
  alignItems: 'center',
  gap: '12px',
  padding: '6px 8px',
};

export const FAILURE_TABLE_GRID_COLUMN = {
  type: '2',
  workflowThroughCount: '3 / 5',
  mostRecent: '5',
  beforeAction: '1 / 6',
  action: '6',
};
